import { render, staticRenderFns } from "./examineRejectDialog.vue?vue&type=template&id=70ad3048&"
import script from "./examineRejectDialog.vue?vue&type=script&lang=js&"
export * from "./examineRejectDialog.vue?vue&type=script&lang=js&"
import style0 from "./examineRejectDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports